<router-outlet></router-outlet>
<div class="build-info-badge" [title]="buildInfoTitle">
  front {{ buildInfoLabel }}
</div>
